import { Component, OnInit } from '@angular/core';
import { NavParams, NavController, ModalController, LoadingController } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from 'src/app/services/loading.service';
import { Events } from '@ionic/angular';
import { TouchSequence } from 'selenium-webdriver';
import { SERVICES } from '../../constants/services';
import { env } from '../../environments/environment';
import { FilterModel } from 'src/app/models/FilterModel';
import { TABLES, LABLES, ORDERBY } from '../../constants/tables';
import { CombeniaService } from 'src/app/services/CombeniaService/CombeniaService';
import { DatePipe } from '@angular/common';
import * as cloneDeep from 'lodash/cloneDeep';
import * as moment from 'moment';
import { CombeniaSyncService } from 'src/app/services/CombeniaService/CombeniaSyncService';
import { BackendDataService } from 'src/app/services/backendDataService/backendDataService';
import {UserType, UserModel} from 'src/app/models/UserModel'

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
    elements: Array<any>;
    title: string;
    sectionId: string;
    data: any = {};
    file: any;
    values: any = {};
    type: string;
    disableSave: boolean;
    allStores:Array<any>;

    constructor(
        private modalController: ModalController,
        private navParams: NavParams,
        private http: HttpClient,
        public loadingService: LoadingService,
        public alertCtrl: AlertController,
        private translateService: TranslateService,
        public events: Events,
        private filterModel: FilterModel,
        public combenia: CombeniaService,
        public datePipe: DatePipe,
        public sync: CombeniaSyncService,
        public backend: BackendDataService,
        public loadingController: LoadingController,
        public user: UserModel

    ) {
    }

    ionViewWillEnter() {
        this.sectionId = this.navParams.get('sectionId');
        this.elements = cloneDeep(this.navParams.get('camps'));
        this.type = this.navParams.get('type');

        this.title = this.navParams.get('title') ? this.navParams.get('title') : LABLES[this.sectionId][this.type];
        this.data = (this.navParams.get('data') ? cloneDeep(this.navParams.get('data')) : {});
        this.renderFields();
        this.disableSave = this.sectionId === 'USER_MANAGEMENT' ||this.sectionId == "COMPETITORS_IN_STORE" ? true : false;

    }
    async myDismiss() {
        await this.modalController.dismiss();
    }

    async changeListener($event, element) {
        if (element.input.type === 'file') {
            $event.target.getInputElement().then(data => {
                this.file = data.files[0];
            });
        }
       
        if (element.id === 'user_type') {
            this.showHideFields($event.detail.value);
        }
        // Disable save if not all the fields are filled
        if (this.sectionId === 'USER_MANAGEMENT'){
            let unfilled = await this.elements.filter(elem => elem.input.type && !elem.input.hide && (!this.data[elem.id] || this.data[elem.id].length==0)? true : false);
            this.disableSave = unfilled.length > 1 ||( unfilled.length>0 && unfilled[0].id!="main_customer");
            if(element.id=="main_customer")
            {
                this.data["stores"]=[];
                this.allStores.forEach((store)=>{
                    if(this.data["main_customer"].includes(store.main_cust_code))
                    {
                        this.data["stores"].push(store.id_store);
                    }
                        
                })
                
            }
        }
        if (this.sectionId == "COMPETITORS_IN_STORE") {
            if (element.id == "id_supplier") {
                this.data["brand_code"] = "";
                this.elements.forEach(async (elem, index) => {
                    if (elem.id == "brand_code") {
                        elem.options = await this.filterModel.getFilterValue("brand_all", [{
                            criteria: "suppliers",
                            selected: [this.data["id_supplier"]],               
                        }])
                    }

                })


            }
            let unfilled = await this.elements.filter(elem => elem.input.type && !elem.input.hide && (!this.data[elem.id] || this.data[elem.id].length==0)? true : false);
            this.disableSave = unfilled.length > 0;
           

        }
    }

    ngOnInit() {
    }

    getUploadUrl() {
        if (!SERVICES[this.sectionId] || !SERVICES[this.sectionId].upload){
            return '';
        }
        return env.serviceUrl + '/' + SERVICES[this.sectionId].upload;
    }

    isUpload() {
        return this.elements[0].id === 'file';
    }

    sendFile() {
        return new Promise((resolve, reject) => {

            let url = this.getUploadUrl();
            let body = new FormData();
            body.append('file', this.file, this.file['name']);
            if(this.sectionId === 'USER_MANAGEMENT'){
                body.append('token', this.sync.getToken());
            }
            if(this.sectionId === 'COMPETITORS_SALES' || this.sectionId === 'SELLOUT_QUICK') {
                body.append('username', this.user.username);
            }
            let request = this.http
                .post(
                    url,
                    body,
                    {}
                )
                .subscribe(
                    success => {
                        resolve(success);
                    },
                    error => {
                        reject(error);
                    },
                    () => {
                        request.unsubscribe();
                    }
                );
        });
    }

    notifyChange() {
        if(this.sectionId === 'SELLOUT_QUICK') {
            this.events.publish(this.sectionId);
        } else {
            this.events.publish(this.sectionId, ORDERBY[this.sectionId].default, 'ASC');
        }
        
    }

    async send() {

        if (this.isUpload()) {
            return this.sendFile();
        } else {
            return this.sendEntity();
        }

    }

    async sendEntity() {
        if(!this.data.main_store)
            delete this.data.main_store;

        
        let finalData = cloneDeep(this.data);
        let token = this.sync.getToken();
        if (this.sectionId === 'USER_MANAGEMENT') {
            finalData.token = token;
           // this.backend.addEditUser(finalData, this.type);
        } else {
            let entity = SERVICES[this.sectionId].entity;
            finalData.synch_status = "updated";

            if (finalData['month_target']) {
                finalData['month_target'] = this.datePipe.transform(finalData['month_target'], 'MM/yyyy');
            }
            if(finalData.door_name && this.sectionId === 'TARGET_MANAGEMENT'){
                finalData.id_store = finalData.door_name;
                delete finalData.door_name;
            }
            for(let key in finalData){
                let item = finalData[key];
                if(typeof item === 'object'){
                    finalData[key] = item.toString();
                }
            }
            console.log(finalData);


            await this.combenia.writeEntity(entity, [await finalData]);
            if(this.data.main_store && this.sectionId === 'STORE_MANAGEMENT') {
                await this.combenia.readEntity("stores", {
                    action: "delete_dual_inventory",
                    id_store:finalData.id_store,
                    main_store:finalData.main_store
                })
            } 
            this.events.publish(this.sectionId);
            
            return true;
        }
    }

    async save() {
        if (this.sectionId) {
            this.loadingService.createLoading('');
            let loader = this.loadingController.create({});
            try {
                let success = await this.send();
                let alert = await this.alertCtrl.create({
                    header: this.translateService.instant('INFO').toUpperCase(),
                    message: this.translateService.instant('OPERATION_SUCCESSFUL'),
                    buttons: [
                        {
                            text: this.translateService.instant('OK'),
                            handler: async () => {
                                this.notifyChange();
                                await this.modalController.dismiss();
                            }
                        },
                    ]
                });
                await alert.present();
                this.loadingService.dismissLoading();

            } catch (e) {
                let errorMessage = "";
                if(this.sectionId === 'COMPETITORS_SALES' || this.sectionId === 'SELLOUT_QUICK') {
                    if(e.error && e.error.message) {
                        errorMessage = e.error.message;
                        if(errorMessage.indexOf("\n") != -1) {
                            errorMessage = errorMessage.replace("\n", "<br/>")
                        }
                    }
                } else {
                    if(e.error && e.error.error)
                    errorMessage = e.error.error;
                }
                let alert = await this.alertCtrl.create({
                    header: this.translateService.instant('ERROR').toUpperCase(),
                    message: errorMessage,
                    buttons: [
                        {
                            text: this.translateService.instant('OK'),
                            handler: async () => {
                            }
                        },
                    ]
                });
                alert.present();
                this.loadingService.dismissLoading();
                return null;
            }
            this.loadingService.dismissLoading();
        } else {
            await this.modalController.dismiss();
        }
    } 

    async renderFields() {
        await this.elements.forEach((elem, index) => {
            if (elem.input.type === 'select') {
                if (this.data[elem.id] && elem.input.multiple) {
                    this.data[elem.id] = this.data[elem.id].split(',');
                }

                this.filterModel.getFilterValue(elem.input.options).then(response => {
                    if (response) {
                        if(elem.input.options=="main_store" && this.data.id_store)
                        {
                            response= response.filter((st)=>{
                                return st.id!=this.data.id_store;
                            })
                        }
                        elem.options = response;
                    }
                });
            }
            if (elem.input.type === 'date') {
                if (this.data[elem.id]) {
                    this.data[elem.id] = this.data[elem.id].split('/');
                    this.data[elem.id].splice(1, 0, '1');
                    this.data[elem.id] = this.data[elem.id].toString().replace(/,/g, '/');
                }
            }
            
        });

        // when editing a record that has STORE as field
        if(this.sectionId !== 'STORE_MANAGEMENT'){
            if (this.data.door_names || this.data.door_name) {
                let tempStore = this.data.door_names ? this.data.door_names : this.data.door_name;
                let type = typeof tempStore;
                await this.filterModel.getFilterValue('store').then(async data => {
                    let val: any = await data.filter(item => {
                        return type === 'object' ? tempStore.includes(item.description) : tempStore === item.description;
                    });
                    if (type === 'object'){
                        this.data.stores = val.length > 0 ? val.map(item => item.id) : [];
                    } else {
                        this.data.door_name = val[0].id;
                    }
                });
            }
        }

        if (this.sectionId === 'USER_MANAGEMENT') {
            let options = [];
            await this.filterModel.getUserDivisions().then(data => {
                data.forEach(item => {
                    options.push({
                        description: Object.values(item).toString().replace(/,/g, ' - '),
                        id: item
                    });
                });
            });
            
            console.log(this.allStores)
            this.elements.push({
                id: 'divisions',
                title: 'DIVISIONS',
                input: { type: 'select', hide: true },
                options: options
            });
            // Change stores select index, and put it at the end of the array
            let stores = this.elements.find(elem => elem.id === 'door_names');
            if (stores) {
                stores.id = 'stores';
                this.elements.push(stores);
                this.elements.splice(this.elements.indexOf(stores), 1);
            }
            if (this.data.user_type) {
                this.showHideFields(this.data.user_type);
            }
            
        }
        if(this.sectionId=="COMPETITORS_SALES")
        {
            this.data.selling_date=this.data.order_date
        }
    }

    showHideFields(value){
        
    }

}
